import { useTranslate } from "../../../../../hooks/useTranslate";
import "./AgreementBox.css";
import cx from "classnames";

const AgreementBox = (props) => {
    const {
        isRecommended,
        isSelected, onClick,
        title, children,
        className,
        disabled,
    } = props;

    const { t } = useTranslate();

    return (
        <div
            role="button"
            className={cx(
                "agreement-box",
                { "agreement-box--selected": isSelected },
                className,
            )}
            onClick={disabled ? undefined : onClick}
            tabIndex={0}
            aria-disabled={disabled}
        >
            {isRecommended && (<div className="agreement-box__recommended">{t("enrolmentAgreement.recommended")}</div>)}
            {title && (<div className="agreement-box__title">{title}</div>)}
            <div className="agreement-box__content">
                {children}
            </div>
            <div className="agreement-box__button">
                {t(isSelected ? "enrolmentAgreement.selected" : "enrolmentAgreement.selectAgreement")}
            </div>
        </div>
    );
};

export default AgreementBox;
